import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const LandUseZoningSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.landUseZoning;
  const hasData = !!data && !!(data.currentZoning || data.adjacentLandUses || data.compatibilityAnalysis);
  return (
    <SectionShell label={label} hasData={hasData}>
      {data?.currentZoning && <EditorialSubsection theme={theme} label="Current Zoning">{data.currentZoning}</EditorialSubsection>}
      {data?.adjacentLandUses && <EditorialSubsection theme={theme} label="Adjacent Land Uses">{data.adjacentLandUses}</EditorialSubsection>}
      {data?.compatibilityAnalysis && <EditorialSubsection theme={theme} label="Compatibility Analysis">{data.compatibilityAnalysis}</EditorialSubsection>}
    </SectionShell>
  );
};
